module.exports = __webpack_public_path__ + "static/media/468x60_0058_en.c00ccc89.jpg";